var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('b-img',{staticStyle:{"border-radius":"15px"},attrs:{"src":"images/rwkassel.jpg","fluid":""}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('presentation.costmanagement'))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }